class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summaryElement = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsToggle.querySelector('.header__submenu');
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.openedByHover = false;

    this.addEventListener('focusin', this.onFocusIn.bind(this));
    this.addEventListener('focusout', this.onHeaderFocusOut.bind(this));
    this.addEventListener('keyup', this.onHeaderKeyUp.bind(this));
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onFocusIn() {
    if (!this.desktopQuery.matches) return;
    if (this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryElement.setAttribute('aria-expanded', 'true');
    this.openedByHover = false;
  }

  onHeaderFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onHeaderKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    this.close();
    this.summaryElement.focus();
  }

  onMouseEnter() {
    if (!this.desktopHoverQuery.matches) return;
    if (this.mainDetailsToggle.hasAttribute('open')) return;

    this.mainDetailsToggle.setAttribute('open', '');
    this.summaryElement.setAttribute('aria-expanded', 'true');
    this.openedByHover = true;
  }

  onMouseLeave() {
    if (!this.desktopHoverQuery.matches) return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    const activeElement = document.activeElement;
    const focusIsInsideSubmenu = activeElement && this.content.contains(activeElement);

    if (focusIsInsideSubmenu) return;

    this.close();
    this.openedByHover = false;
  }

  onToggle() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.openedByHover = false;
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
